import dynamic, { DynamicOptions } from 'next/dynamic'
import { ContinueWatchingCollectionProps } from '@/organisms/WatchNowCollection/ContinueWatchingCollection/ContinueWatchingCollection'
import { logger } from '@/utils/logging'

export const ContinueWatchingCollection = dynamic(
  import('./ContinueWatchingCollection')
    .then((mod) => mod.ContinueWatchingCollection)
    .catch((err) =>
      logger().error(`Failed to load the ContinueWatchingCollection!`, err),
    ) as DynamicOptions<ContinueWatchingCollectionProps>,
  { ssr: false },
)
